import { useTranslation } from 'react-i18next'
import BulletPoint from './BulletPoint'

export default function Features() {
  const { t } = useTranslation()

  return (
    <div className="space-y-11">
      <BulletPoint
        text={t('pages.checkout.plans.bulletPoints.text1')}
        title={t('pages.checkout.plans.bulletPoints.title1')}
      />

      <BulletPoint
        text={t('pages.checkout.plans.bulletPoints.text2')}
        title={t('pages.checkout.plans.bulletPoints.title2')}
      />

      <BulletPoint
        text={t('pages.checkout.plans.bulletPoints.text3')}
        title={t('pages.checkout.plans.bulletPoints.title3')}
      />

      <BulletPoint
        text={t('pages.checkout.plans.bulletPoints.text4')}
        title={t('pages.checkout.plans.bulletPoints.title4')}
      />
    </div>
  )
}
